// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import confetti from "canvas-confetti";

// const API = process.env.REACT_APP_API_URL;

// const PlaylistQuiz = ({ playlistId, onClose }) => {
//   const [questions, setQuestions] = useState([]);
//   const [currentQuestion, setCurrentQuestion] = useState(0);
//   const [selected, setSelected] = useState(null);
//   const [score, setScore] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [finished, setFinished] = useState(false);

//   useEffect(() => {
//     if (!playlistId) {
//       console.warn("❌ playlistId missing");
//       setLoading(false);
//       return;
//     }

//     const fetchQuiz = async () => {
//       try {
//         const res = await axios.get(`${API}/playlist/generate-playlist-quiz`, {
//           params: { playlistId },
//         });

//         setQuestions(res.data?.data || []);
//       } catch (err) {
//         console.error("❌ Quiz fetch error:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchQuiz();
//   }, [playlistId]);

//   const letterToIndex = (letter) => {
//     // Convert "A" → 0, "B" → 1, etc.
//     return letter.charCodeAt(0) - 65;
//   };

//   const handleNext = () => {
//     const q = questions[currentQuestion];

//     if (selected !== null) {
//       const correctIndex = letterToIndex(q.answer);
//       if (q.options[correctIndex] === selected) {
//         setScore((s) => s + 1);
//       }
//     }

//     setSelected(null);

//     if (currentQuestion + 1 < questions.length) {
//       setCurrentQuestion((i) => i + 1);
//     } else {
//       setFinished(true);
//       confetti({ particleCount: 150, spread: 80, origin: { y: 0.6 } });
//     }
//   };

//   if (loading) {
//     return <p className="text-center text-black">Generating quiz… 🤖</p>;
//   }

//   if (!questions.length) {
//     return (
//       <div className="text-center text-black">
//         <p>No quiz available</p>
//         <button
//           className="bg-indigo-600 py-2 px-4 rounded-lg"
//           onClick={onClose}
//         >
//           Try again
//         </button>
//       </div>
//     );
//   }

//   if (finished) {
//     return (
//       <div className="text-center text-green-400 space-y-4">
//         <h2 className="text-3xl font-bold">🎉 Quiz Completed!</h2>
//         <p className="text-xl">
//           Score: {score} / {questions.length}
//         </p>
//         <button
//           onClick={onClose}
//           className="px-6 py-3 text-white rounded-xl bg-indigo-600"
//         >
//           Close Quiz
//         </button>
//       </div>
//     );
//   }

//   const q = questions[currentQuestion];

//   return (
//     <div className="text-black space-y-6">
//       <div className="flex justify-between">
//         <span className="text-sm opacity-70">
//           Question {currentQuestion + 1} / {questions.length}
//         </span>
//         <button onClick={onClose}>✕</button>
//       </div>

//       <h2 className="text-xl font-semibold">{q.question}</h2>

//       <div className="grid gap-3">
//         {q.options.map((opt, i) => (
//           <button
//             key={i}
//             onClick={() => setSelected(opt)}
//             className={`p-3 rounded-xl text-left ${
//               selected === opt
//                 ? "bg-indigo-600"
//                 : "text-gray-200 bg-slate-800 hover:bg-slate-700"
//             }`}
//           >
//             {opt}
//           </button>
//         ))}
//       </div>

//       <div className="flex justify-end">
//         <button
//           disabled={!selected}
//           onClick={handleNext}
//           className={`px-6 py-2 rounded-xl ${
//             selected ? "bg-green-500" : "bg-gray-600 cursor-not-allowed"
//           }`}
//         >
//           {currentQuestion + 1 === questions.length ? "Finish" : "Next"}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default PlaylistQuiz;

// *! wuiz with highlighted the correct answer
import React, { useEffect, useState } from "react";
import axios from "axios";
import confetti from "canvas-confetti";

const API = process.env.REACT_APP_API_URL;

const PlaylistQuiz = ({ playlistId, onClose }) => {
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [score, setScore] = useState(0);
  const [loading, setLoading] = useState(true);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    if (!playlistId) return;

    const fetchQuiz = async () => {
      try {
        const res = await axios.get(`${API}/playlist/generate-playlist-quiz`, {
          params: { playlistId },
        });
        setQuestions(res.data?.data || []);
      } catch (err) {
        console.error("Quiz fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchQuiz();
  }, [playlistId]);

  const handleNext = () => {
    const q = questions[currentQuestion];
    const correctIndex = "ABCD".indexOf(q.answer);

    if (selectedIndex === correctIndex) setScore((s) => s + 1);

    // move to next question
    setSelectedIndex(null);
    if (currentQuestion + 1 < questions.length) {
      setCurrentQuestion((q) => q + 1);
    } else {
      setFinished(true);
      confetti({ particleCount: 150, spread: 80, origin: { y: 0.6 } });
    }
  };

  if (loading)
    return <p className="text-center text-black">Generating quiz… 🤖</p>;

  if (!questions.length)
    return (
      <div className="text-center text-black">
        <p>No quiz available</p>
        <button
          className="bg-indigo-600 py-2 px-4 rounded-lg"
          onClick={onClose}
        >
          Try again
        </button>
      </div>
    );

  if (finished)
    return (
      <div className="text-center text-green-400 space-y-4">
        <h2 className="text-3xl font-bold">🎉 Quiz Completed!</h2>
        <p className="text-xl">
          Score: {score} / {questions.length}
        </p>
        <button
          onClick={onClose}
          className="px-6 py-3 text-white rounded-xl bg-indigo-600"
        >
          Close Quiz
        </button>
      </div>
    );

  const q = questions[currentQuestion];
  const correctIndex = "ABCD".indexOf(q.answer);

  return (
    <div className="text-black space-y-6">
      <div className="flex justify-between">
        <span className="text-sm opacity-70">
          Question {currentQuestion + 1} / {questions.length}
        </span>
        <button onClick={onClose}>✕</button>
      </div>

      <h2 className="text-xl font-semibold">{q.question}</h2>

      <div className="grid gap-3">
        {q.options.map((opt, i) => {
          let bgClass = "bg-slate-800 text-gray-200 hover:bg-slate-700";

          if (selectedIndex !== null) {
            if (i === correctIndex)
              bgClass = "bg-green-600 text-white"; // correct
            else if (i === selectedIndex) bgClass = "bg-red-600 text-white"; // wrong selection
          } else if (i === selectedIndex) {
            bgClass = "bg-indigo-600 text-white"; // current selection before Next
          }

          return (
            <button
              key={i}
              onClick={() => setSelectedIndex(i)}
              className={`p-3 rounded-xl text-left ${bgClass}`}
              disabled={selectedIndex !== null} // prevent changing selection after answer
            >
              {opt}
            </button>
          );
        })}
      </div>

      <div className="flex justify-end">
        <button
          disabled={selectedIndex === null}
          onClick={handleNext}
          className={`px-6 py-2 rounded-xl ${
            selectedIndex !== null
              ? "bg-green-500"
              : "bg-gray-600 cursor-not-allowed"
          }`}
        >
          {currentQuestion + 1 === questions.length ? "Finish" : "Next"}
        </button>
      </div>
    </div>
  );
};

export default PlaylistQuiz;
